/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/extrude 层；
 * 2. 负责定义拉伸切除特征原型对象；
 * 3. 该类仅承载“切除”这一语义标签，公共骨架复用拉伸族基类。
 */

import { ExtrudeFeaturePrototype } from './ExtrudeFeaturePrototype';

/**
 * 拉伸切除特征原型。
 */
export class CutExtrudeFeaturePrototype extends ExtrudeFeaturePrototype {}
